import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the tableBetShopCashierView.
 * Extends the JetView class to create a specific view for the cashier.
 */
export default class tableBetShopCashierView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format based on the application configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the URL
        const cur_user = this.getParam('user', true);
        // Preserve the context of 'this' for use in nested functions
        var cthis = this;
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // Define a datatable view
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            id: 'datatable2', // ID for the datatable
                            select: true, // Enable row selection
                            minHeight: 300, // Minimum height of the datatable
                            columns: [
                                {
                                    id: 'rating3', // Column ID for rating
                                    header: '', // Header for the column
                                    width: 50, // Width of the column
                                    height: 25, // Height of the column
                                    tooltip: _('Detalles'), // Tooltip text for the column
                                    template: function (obj) {
                                        // Template function for rendering
                                        return "<span class='webix_icon wxi-close details'></span>"; // Render a close icon
                                    },
                                },
                                {
                                    id: 'id', // Column ID for ID
                                    header: 'ID', // Header for the column
                                    width: 140, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName', // Column ID for UserName
                                    header: _('Usuario'), // Header for the column
                                    width: 140, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name', // Column ID for Name
                                    header: _('Nombre'), // Header for the column
                                    width: 140, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CurrencyId', // Column ID for CurrencyId
                                    header: _('Moneda'), // Header for the column
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IdBetShop', // Column ID for IdBetShop
                                    header: _('Id punto de venta'), // Header for the column
                                    width: 140, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserNameBetShop', // Column ID for UserNameBetShop
                                    header: _('Nombre punto de venta'), // Header for the column
                                    width: 140, // Width of the column
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handlers for click events
                                open: function (euv, id) {
                                    // Handler for opening details
                                    $$('tableAdvertisingCashier').show(); // Show the advertising cashier table
                                    cthis.app.callEvent(
                                        'advertisingCashier:select', // Trigger select event
                                        [id], // Pass the selected ID
                                    );
                                },
                                details: function (euv, id) {
                                    // Handler for details click
                                    if (
                                        cthis.getUrl()[0].page !== 'betShopManagement' // Check current page
                                    ) {
                                        cthis.show(
                                            '/top/betShopManagement?user=' +
                                                id +
                                                '/betShopManagement.informationBetShop', // Show bet shop management details
                                        );
                                        cthis.app.callEvent('title:betShop', [{}]); // Trigger title event
                                    } else {
                                        cthis.show(
                                            '/betShopManagement.informationBetShop', // Show bet shop management details
                                        );
                                    }
                                },
                                edit: function (euv, id) {
                                    // Handler for edit click
                                    if (
                                        cthis.getUrl()[0].page !== 'betShopManagement' // Check current page
                                    )
                                        cthis.show(
                                            '/top/betShopManagement?user=' +
                                                id +
                                                '/betShopManagement.informationBetShop', // Show bet shop management for editing
                                        );
                                    else
                                        cthis.show(
                                            '/betShopManagement.informationBetShop', // Show bet shop management for editing
                                        );
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Set data fetch configuration
                            pager: 'pagerA', // ID for the pager component
                            on: {
                                // Event handlers for datatable events
                                onItemDblClick: (id) => {
                                    // Handler for double-click on item
                                    if (
                                        devConfig.getPermAction(
                                            'permComissions',
                                            'Edit', // Check edit permissions
                                        )
                                    ) {
                                        if (
                                            this.getUrl()[0].page !== 'betShopManagement' // Check current page
                                        )
                                            this.show(
                                                '/top/betShopManagement?user=' +
                                                    id +
                                                    '/betShopManagement.informationBetShop', // Show bet shop management for editing
                                            );
                                        else
                                            this.show(
                                                '/betShopManagement.informationBetShop', // Show bet shop management for editing
                                            );
                                    }
                                },
                            },
                        },
                    ],
                },
            ],
        }; // Placeholder for the view's configuration content
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Reference to the data table component
        grid = $$('datatable2');
        // Get the current user parameter from the application context
        const cur_user = this.getParam('user', true);
        var url;
        // Construct the API URL based on the presence of the current user
        if (cur_user != undefined) {
            url = devConfig.geturlApi() + 'es/BetShop/GetCashDesks?FromId=' + cur_user;
        } else {
            url = devConfig.geturlApi() + 'es/BetShop/GetCashDesks';
        }
        // Listen for the 'cashier:filter' event to apply filters to the data
        this.on(this.app, 'cashier:filter', (filterData) => {
            // Convert filter data object into an array of entries
            var object = Object.entries(filterData);
            var string1 = '';
            // Iterate through each filter entry
            for (var i = 0; i < object.length; i++) {
                // Check if the filter value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filtering
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Append other filter parameters to the query string
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle object type filter values
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through the nested object entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Process 'start' date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Process 'end' date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Log the constructed query string for debugging
            console.log(string1);
            // Clear existing data in the grid
            grid.clearAll();
            // Load new data into the grid with the constructed URL and parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&sort[' + by + ']=' + dir);
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Retrieve the clicked item from the grid
            var item = this.getItem(id);
            // Trigger a custom event with the item's ID
            this.$scope.app.callEvent('user:id', [item.Id]);
        });

        // Listen for the 'addCashie:button' event on the app
        this.on(this.app, 'addCashie:button', (filter) => {
            // Show the popup window for adding a cashier
            popupAdd.show();
        });

        // Create a popup window for adding a cashier
        var popupAdd = webix.ui({
            view: 'window',
            id: 'addwinCasshier',
            head: {
                view: 'toolbar',
                cols: [
                    // Label for the window title
                    { view: 'label', label: _('Añadir Cajero') },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        // Close the window when the icon is clicked
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            width: 5000, // Set the width of the window
            body: {
                view: 'form',
                id: 'saveform', // ID for the form
                elements: [
                    {
                        view: 'text',
                        name: 'UserName', // Field for username
                        label: _('Usuario'),
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                    },
                    {
                        view: 'text',
                        name: 'Name', // Field for name
                        label: _('Nombre'),
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                    },
                    {
                        view: 'text',
                        name: 'Password', // Field for password
                        label: _('Contraseña'),
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                    },
                    {
                        view: 'text',
                        name: 'MinBet', // Field for minimum bet
                        label: _('Min Apuesta'),
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                        type: 'number', // Specify the input type as number
                        value: '0', // Default value
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                // Close the window when clicked
                                click: function () {
                                    this.getTopParentView().hide();
                                },
                            },
                            {
                                view: 'button',
                                type: 'form', // Specify button type as form
                                value: _('Guardar'), // Save button
                                // Handle the save action when clicked
                                click: function ($e) {
                                    // Get values from the form
                                    var values = $$('saveform').getValues();
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for the request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/BetShop/SaveCashDesks', // API endpoint for saving cashier data
                                            '{"FromId":' +
                                                cur_user +
                                                ',"UserName":"' +
                                                values.UserName +
                                                '","Name":"' +
                                                values.Name +
                                                '","Password":"' +
                                                values.Password +
                                                '","ComputerId":"' +
                                                values.ComputerId +
                                                '","MinBet":"' +
                                                values.MinBet +
                                                '","MaxBetLive":"' +
                                                values.MaxBetLive +
                                                '","MaxBetPreMatch":"' +
                                                values.MaxBetPreMatch +
                                                '","PreMatchPercentage":"' +
                                                values.PreMatchPercentage +
                                                '","LivePercentage":"' +
                                                values.LivePercentage +
                                                '","DepositCupo":"' +
                                                values.DepositCupo +
                                                '","RecargasPercentage":"' +
                                                values.RecargasPercentage +
                                                '"}', // JSON payload for the request
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Show error message on failure
                                                    webix.message(_('Error! '));
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Show success message and reload grid on success
                                                    webix.message(_('Cajero Agregado'));
                                                    grid.clearAll(); // Clear the grid
                                                    grid.load(url); // Reload the grid data
                                                },
                                            },
                                        );
                                    $$('saveform').clear(); // Clear the form fields
                                    this.getTopParentView().hide(); // Close the popup window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Create a popup window for editing cashier details
        var popupEdit = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'editwinCashier', // Unique identifier for the window
            head: _('Editar Cajero'), // Header text for the window
            position: 'center', // Position the window in the center of the screen
            modal: true, // Make the window modal
            width: 5000, // Set the width of the window
            body: {
                view: 'form', // Define the body as a form
                id: 'editformCashier', // Unique identifier for the form
                elements: [
                    // Define the elements within the form
                    {
                        view: 'text', // Text input for ID
                        name: 'id', // Name of the input field
                        label: 'ID', // Label for the input field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        disabled: true, // Disable the input field
                    },
                    {
                        view: 'text', // Text input for username
                        name: 'UserName', // Name of the input field
                        label: _('Usuario'), // Label for the input field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type for the input
                    },
                    {
                        view: 'text', // Text input for name
                        name: 'Name', // Name of the input field
                        label: _('Nombre'), // Label for the input field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type for the input
                    },
                    {
                        view: 'combo', // Combo box for currency selection
                        label: _('Moneda'), // Label for the combo box
                        name: 'CurrencyId', // Name of the input field
                        disabled: true, // Disable the combo box
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the combo box
                        options: [], // Options for the combo box (empty initially)
                    },
                    {
                        view: 'text', // Text input for computer ID
                        name: 'ComputerId', // Name of the input field
                        label: _('Computador ID'), // Label for the input field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type for the input
                    },
                    {
                        view: 'text', // Text input for minimum bet
                        name: 'MinBet', // Name of the input field
                        label: _('Min Apuesta'), // Label for the input field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type for the input
                        type: 'number', // Input type as number
                        value: '0', // Default value
                    },
                    {
                        view: 'text', // Text input for maximum live bet
                        name: 'MaxBetLive', // Name of the input field
                        label: _('Max Apuesta Live'), // Label for the input field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type for the input
                        type: 'number', // Input type as number
                        value: '0', // Default value
                    },
                    {
                        view: 'text', // Text input for maximum pre-match bet
                        name: 'MaxBetPreMatch', // Name of the input field
                        label: _('Max Apuesta PreMatch'), // Label for the input field
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type for the input
                        type: 'number', // Input type as number
                        value: '0', // Default value
                    },
                    {
                        cols: [
                            // Define a layout with columns for buttons
                            {
                                view: 'button', // Button for cancel action
                                value: _('Cancelar'), // Button text
                                click: function () {
                                    // Click event handler
                                    this.getTopParentView().hide(); // Hide the popup window
                                },
                            },
                            {
                                view: 'button', // Button for save action
                                type: 'form', // Button type as form submission
                                value: _('Guardar'), // Button text
                                click: function ($e) {
                                    // Click event handler
                                    var values = $$('editformCashier').getValues(); // Get form values
                                    webix // Perform an AJAX request
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API URL for the request
                                                'es/BetShop/UpdateCashDesks',
                                            '{"FromId":"' + // JSON payload for the request
                                                values.id +
                                                '","UserName":"' +
                                                values.UserName +
                                                '","Name":"' +
                                                values.Name +
                                                '","Password":"' +
                                                values.Password +
                                                '","Type":"' +
                                                values.Type +
                                                '","CurrencyId":"' +
                                                values.CurrencyId +
                                                '","ComputerId":"' +
                                                values.ComputerId +
                                                '","MinBet":"' +
                                                values.MinBet +
                                                '","MaxBetLive":"' +
                                                values.MaxBetLive +
                                                '","MaxBetPreMatch":"' +
                                                values.MaxBetPreMatch +
                                                '","PreMatchPercentage":"' +
                                                values.PreMatchPercentage +
                                                '","LivePercentage":"' +
                                                values.LivePercentage +
                                                '","DepositCupo":"' +
                                                values.DepositCupo +
                                                '","RecargasPercentage":"' +
                                                values.RecargasPercentage +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Error callback
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Success callback
                                                    webix.message(_('Cajero Agregado')); // Show success message
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(url); // Reload the grid data
                                                },
                                            },
                                        );
                                    $$('editformCashier').clear(); // Clear the form fields
                                    this.getTopParentView().hide(); // Hide the popup window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        /**
         * Binds the 'editformCashier' element to the 'datatable2' element.
         * This allows for interaction between the form and the data table,
         * enabling data manipulation and updates based on user input.
         */
        $$('editformCashier').bind($$('datatable2')); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
